import { render } from "./StaffRegister.vue?vue&type=template&id=107f8c4a&scoped=true"
import script from "./StaffRegister.vue?vue&type=script&lang=js"
export * from "./StaffRegister.vue?vue&type=script&lang=js"

import "./StaffRegister.vue?vue&type=style&index=0&id=107f8c4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107f8c4a"]])

export default __exports__